export interface BudgetConfigurations {
  isAllowed: boolean
}

export const defaultBudgetConfig: BudgetConfigurations = {
  isAllowed: false,
}
